import { useCallback, useEffect, useRef } from "react";
import { Party, UserAccount } from "../data/types";
import SignalRServiceManager from "./SignalRServiceManager";

type PartySignalRProps = {
    primaryAccount?: UserAccount;
    onUpsertParty?: (parties: Party[]) => void;
}
export const usePartySignalR = (props: PartySignalRProps) => {
    const { primaryAccount, onUpsertParty } = props;
    const messageName = "upsertParty";

    // Use useRef to maintain stable reference
    const onUpsertPartyRef = useRef(onUpsertParty);

    useEffect(() => {
        onUpsertPartyRef.current = onUpsertParty;
    }, [onUpsertParty]);

    const upsertHandler = useCallback((objJson: string) => {
        try {
            const theObj = JSON.parse(objJson);
            onUpsertPartyRef.current?.(theObj);
        } catch (error) {
            console.error("Failed to parse signalR message:", error, objJson);
        }
    }, []); // Now stable

    useEffect(() => {
        let signalRManager: Awaited<ReturnType<typeof SignalRServiceManager.getInstance>> | null = null;

        const setupSignalR = async () => {
            if (primaryAccount) {
                signalRManager = await SignalRServiceManager.getInstance(primaryAccount);
                signalRManager?.on(messageName, upsertHandler);
            }
        };

        setupSignalR();

        return () => {
            signalRManager?.off(messageName, upsertHandler);
        };
    }, [primaryAccount, upsertHandler]);

    return null;
}